import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { DATA_SERVICE_BASE_URL } from '../config/runtime';

export default function AccountActivationPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(token ? '' : 'The verification link is missing its token. Open the full link from your email.');
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setBusy(true);
    try {
      const query = new URLSearchParams({ token, newPassword: password });
      const response = await fetch(`${DATA_SERVICE_BASE_URL}/api/users/reset-password?${query}`, { method: 'POST' });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.message || body.error || 'This verification link is invalid or has expired.');
      }
      navigate('/login?verified=1', { replace: true });
    } catch (activationError) {
      setError(activationError instanceof Error ? activationError.message : 'Unable to activate the account.');
    } finally {
      setBusy(false);
    }
  };

  const passwordValid = password.length >= 8
    && /[A-Z]/.test(password)
    && /[a-z]/.test(password)
    && /\d/.test(password)
    && /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return (
    <div className="auth">
      <section className="auth__card">
        <div className="auth__brand"><span className="auth__logo" aria-hidden>🎙️</span><span className="auth__brandName">DocuCast</span></div>
        <h1>Verify your email</h1>
        <p className="auth__tagline">Set a password to activate your ScoutCast account.</p>
        <form className="auth__form" onSubmit={submit}>
          <label className="field">
            <span className="field__label">Password</span>
            <input className="input" type="password" autoComplete="new-password" required value={password} onChange={event => setPassword(event.target.value)} />
          </label>
          <label className="field">
            <span className="field__label">Confirm password</span>
            <input className="input" type="password" autoComplete="new-password" required value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} />
          </label>
          <p className="muted">Use at least 8 characters, with uppercase, lowercase, number, and special character.</p>
          {error && <div className="auth__error" role="alert">{error}</div>}
          <button className="btn btn--primary btn--block" type="submit" disabled={!token || !passwordValid || password !== confirmPassword || busy}>
            {busy ? 'Activating…' : 'Activate account'}
          </button>
        </form>
        <p className="auth__tagline"><Link to="/login">Back to sign in</Link></p>
      </section>
    </div>
  );
}